<script lang="ts">
  import { BUTTON_SIZE, BUTTON_VARIANT } from '$lib/constants/constants';
  import Checkbox from '../../control/Checkbox.svelte';
  import TextInput from '../../control/TextInput.svelte';
  import Button from '$lib/components/control/Button.svelte';
  import Tick from '../../../../assets/svgs/tick.svelte';

  export let title: string;
  export let description: string;
  export let isSubmitted: boolean;
  export let errorMessage: string;
  export let checkboxError: boolean;
  export let handleSubmit: any;

  let textInputValue: string = '';

  $: success = isSubmitted && !errorMessage && !checkboxError ? true : false;
</script>

<article class="flex md:justify-center px-4 py-8">
  <div class="max-w-800 w-full bg-gray-50 flex rounded-xl py-8 px-4 md:py-12 md:justify-center">
    <div class=" flex flex-col w-full md:w-[37rem] md:px-0">
      <section class="flex flex-col gap-2 text-center md:w-full md:text-start">
        <h2 class="text-lg font-semibold text-gray-900 md:text-display-xxs">{title}</h2>
        <p class="text-gray-600">{description}</p>
      </section>
      <form
        on:submit|preventDefault={handleSubmit}
        class="flex flex-col mt-4 gap-4 md:grid md:grid-row-2 md:grid-cols-1 md:w-full md:grid-row-col"
      >
        <TextInput
          placeholder="Enter your email."
          name="email"
          value={textInputValue}
          {success}
          {errorMessage}
        />
        <div class="md:order-last md:col-span-2">
          <Checkbox
            label="I agree to receive marketing emails from Sweat."
            {success}
            error={checkboxError}
          />
        </div>
        <div>
          <Button
            text="Subscribe"
            variant={BUTTON_VARIANT.OUTLINED}
            buttonSize={BUTTON_SIZE.LARGE}
            customClass="w-full lg:w-[10rem] md:justify-self-end plausible-event-name=subscribe_newsletter"
            disabled={success}
          >
            <div slot="left">
              {#if success}
                <Tick />
              {/if}
            </div>
          </Button>
        </div>
      </form>
      {#if success}
        <p class="text-sm text-gray-950 font-semibold pt-4">
          Thank you for signing up. Please check your inbox. If you do not see a confirmation email,
          please try again or contact customer service.
        </p>
      {/if}
    </div>
  </div>
</article>
